import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Radio, Input, Select } from "antd";
import fetchHandler from "@/fetch/fetchHandler";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { updateEventMonitorCfg } from "../../../fetch/fetchApi";

const FormItem = Form.Item;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class EventMonitorCfgUpdateClass extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      internationalization: this.props.intl.messages.EventMonitorCfgUpdate,
      
    };
    
    
    
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        //巡检费用数值判断，设备型号长度判断
        if (values.eventName.length > 50)
        {
          message.error('事件名称最大长度不能超过50个字符');
          return;
        }
        const number = /^(\-|\+)?\d+(\.\d+)?$/;
        if (this.props.stubId.eventType == 0)
        {
          if (values.environmentWeatherVal && !number.test(values.environmentWeatherVal))
          {
            message.error('大于环境温度必须填写数值类型');
            return;
          }
          values.eventRule = JSON.stringify({environmentWeatherVal:values.environmentWeatherVal});
        }
        if (this.props.stubId.eventType == 1)
        {
          if (values.maxSnVal && !number.test(values.maxSnVal))
          {
            message.error('同组模块相差不能大于必须填写数值类型');
            return;
          }
          values.eventRule = JSON.stringify({maxSnVal:values.maxSnVal});
        }
        if (this.props.stubId.eventType == 2)
        {
          if (values.brandTVal && !number.test(values.brandTVal))
          {
            message.error('不同品牌模块绝对值差必须填写数值类型');
            return;
          }
          values.eventRule = JSON.stringify({brandTVal:values.brandTVal});
        }
        if (this.props.stubId.eventType == 3)
        {
          if (values.maxAiVal && !number.test(values.maxAiVal))
          {
            message.error('同组模块电流最大最小差值大于必须填写数值类型');
            return;
          }
          if (values.monitorPoint && !number.test(values.monitorPoint))
          {
            message.error('异常采样点必须填写数值类型');
            return;
          }
          if (values.monitorOrder && !number.test(values.monitorOrder))
          {
            message.error('异常订单数必须填写数值类型');
            return;
          }
          values.eventRule = JSON.stringify({maxAiVal:values.maxAiVal, monitorPoint:values.monitorPoint, monitorOrder:values.monitorOrder});
        }
        if (this.props.stubId.eventType == 5)
        {
          if (values.exceptionPayVal && !number.test(values.exceptionPayVal))
          {
            message.error('异常扣费金额必须填写数值类型');
            return;
          }
          if (values.chargeNum && !number.test(values.chargeNum))
          {
            message.error('异常充电度数必须填写数值类型');
            return;
          }
          values.eventRule = JSON.stringify({exceptionPayVal:values.exceptionPayVal,chargeNum:values.chargeNum});
        }
        if (this.props.stubId.eventType == 6)
        {
          if (values.exceptionPayOrderNum && !number.test(values.exceptionPayOrderNum))
          {
            message.error('连续异常订单数必须填写数值类型');
            return;
          }
          values.eventRule = JSON.stringify({exceptionPayOrderNum:values.exceptionPayOrderNum});
        }
        if (this.props.stubId.eventType == 7)
        {
          if (values.offLineNum && !number.test(values.offLineNum))
          {
            message.error('24小时掉线次数必须填写数值类型');
            return;
          }
          values.eventRule = JSON.stringify({offLineNum:values.offLineNum});
        }
        if (this.props.stubId.eventType == 8)
        {
          
          if (values.offLineTime && !number.test(values.offLineTime))
          {
            message.error('离线时长(秒)必须填写数值类型');
            return;
          }
          values.eventRule = JSON.stringify({offLineTime:values.offLineTime});
        }
        
        this.setState({
          btnLoading: true,
        });
        values.id = this.props.stubId.key;
        fetchHandler(updateEventMonitorCfg, {
          ...values,
        }).then((res) => {
          if (this.props.setSelectedRowKeysNull) {
            this.props.setSelectedRowKeysNull();
          }
          if (res && res.code === "success") {
            message.success(this.state.internationalization.msg1); // '操作成功');
            if (this.props.onCancel) {
              this.props.onCancel();
            }
            if (this.props.refreshGrid) {
              this.props.refreshGrid();
            }
          }
          this.setState({
            btnLoading: false,
          });
        });
      }
    });
  };


  render() {
    this.setState({
      environmentWeatherVal:0,
      maxSnVal:0,
      brandTVal:0,
      maxAiVal:0,
      monitorPoint:0,
      monitorOrder:0,
      exceptionPayOrderNum:0,
      chargeNum:0,
      offLineTime:0,
      exceptionPayVal:0,
      offLineNum:0
    })
    const rule = JSON.parse(this.props.stubId.eventRule);
    if (this.props.stubId.eventType == 0)
    {
      this.setState({
        environmentWeatherVal:rule.environmentWeatherVal
      })
    } else if (this.props.stubId.eventType == 1)
    {
      this.setState({
        maxSnVal:rule.maxSnVal
      })
    } else if (this.props.stubId.eventType == 2)
    {
      this.setState({
        brandTVal:rule.brandTVal
      })
    } else if (this.props.stubId.eventType == 3)
    {
      this.setState({
        maxAiVal:rule.maxAiVal,
        monitorPoint:rule.monitorPoint,
        monitorOrder:rule.monitorOrder
      })
    } else if (this.props.stubId.eventType == 5)
    {
      this.setState({
        exceptionPayVal:rule.exceptionPayVal,
        chargeNum:rule.chargeNum
      })
    } else if (this.props.stubId.eventType == 6)
    {
      this.setState({
        exceptionPayOrderNum:rule.exceptionPayOrderNum
      })
    } else if (this.props.stubId.eventType == 7)
    {
      this.setState({
        offLineNum:rule.offLineNum
      })
    } else if (this.props.stubId.eventType == 8)
    {
      this.setState({
        offLineTime:rule.offLineTime
      })
    }
    const sortTypeOption = JSON.parse(JSON.stringify(this.props.levelOption));
    sortTypeOption.shift();
    const { getFieldDecorator } = this.props.form;
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 5 },
      },
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 30 },
        sm: { span: 15, offset: 1 },
      },
    };
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
        <FormItem {...formItemLayout} label={this.state.internationalization.title2}>
              {getFieldDecorator("eventName", {
                rules: [
                  {
                    required: true,
                    message: "请输入事件名称",
                  },
                ],
                initialValue: this.props.stubId == null ? null : this.props.stubId.eventName,
              })(<Input />)}
          </FormItem>
          <FormItem  {...formItemLayout} label={this.state.internationalization.title1}>
            {getFieldDecorator("levelId", {
              rules: [
                {
                  required: true,
                  message: this.state.internationalization.placeholder1, // "请选择运维等级"
                },
              ],
              initialValue: this.props.stubId == null ? '0' : this.props.stubId.levelId,
            })(
              <Select
                  onSelect={(value, option) => {
                    // this.changeTableSort("table1Value", option);
                  }}>
                  {sortTypeOption.map((item) => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.text}
                      </Option>
                    );
                  })}
                </Select>,
              )}
          </FormItem>

          <FormItem hidden={this.props.stubId.eventType != 0} {...formItemLayout} label={this.state.internationalization.title3}>
              {getFieldDecorator("environmentWeatherVal", {
                rules: [
                  {
                    required: true,
                    message: "请输入",
                  },
                ],
                initialValue: this.state.environmentWeatherVal,
              })(<Input />)}
          </FormItem>

          <FormItem hidden={this.props.stubId.eventType != 1} {...formItemLayout} label={this.state.internationalization.title4}>
              {getFieldDecorator("maxSnVal", {
                rules: [
                  {
                    required: true,
                    message: "请输入",
                  },
                ],
                initialValue: this.state.maxSnVal,
              })(<Input />)}
          </FormItem>

          <FormItem hidden={this.props.stubId.eventType != 2} {...formItemLayout} label={this.state.internationalization.title5}>
              {getFieldDecorator("brandTVal", {
                rules: [
                  {
                    required: true,
                    message: "请输入",
                  },
                ],
                initialValue: this.state.brandTVal,
              })(<Input />)}
          </FormItem>

          <FormItem hidden={this.props.stubId.eventType != 3} {...formItemLayout} label={this.state.internationalization.title6}>
              {getFieldDecorator("maxAiVal", {
                rules: [
                  {
                    required: true,
                    message: "请输入",
                  },
                ],
                initialValue: this.state.maxAiVal,
              })(<Input />)}
          </FormItem>

          <FormItem hidden={this.props.stubId.eventType != 3} {...formItemLayout} label={this.state.internationalization.title7}>
              {getFieldDecorator("monitorPoint", {
                rules: [
                  {
                    required: true,
                    message: "请输入",
                  },
                ],
                initialValue: this.state.monitorPoint,
              })(<Input />)}
          </FormItem>

          <FormItem hidden={this.props.stubId.eventType != 3} {...formItemLayout} label={this.state.internationalization.title8}>
              {getFieldDecorator("monitorOrder", {
                rules: [
                  {
                    required: true,
                    message: "请输入",
                  },
                ],
                initialValue: this.state.monitorOrder,
              })(<Input />)}
          </FormItem>

          <FormItem hidden={this.props.stubId.eventType != 5} {...formItemLayout} label={this.state.internationalization.title11}>
              {getFieldDecorator("exceptionPayVal", {
                rules: [
                  {
                    required: true,
                    message: "请输入",
                  },
                ],
                initialValue: this.state.exceptionPayVal,
              })(<Input />)}
          </FormItem>
          <FormItem hidden={this.props.stubId.eventType != 5} {...formItemLayout} label={this.state.internationalization.title13}>
              {getFieldDecorator("chargeNum", {
                rules: [
                  {
                    required: true,
                    message: "请输入",
                  },
                ],
                initialValue: this.state.chargeNum,
              })(<Input />)}
          </FormItem>
          <FormItem hidden={this.props.stubId.eventType != 6} {...formItemLayout} label={this.state.internationalization.title9}>
              {getFieldDecorator("exceptionPayOrderNum", {
                rules: [
                  {
                    required: true,
                    message: "请输入",
                  },
                ],
                initialValue: this.state.exceptionPayOrderNum,
              })(<Input />)}
          </FormItem>

          <FormItem hidden={this.props.stubId.eventType != 7} {...formItemLayout} label={this.state.internationalization.title10}>
              {getFieldDecorator("offLineNum", {
                rules: [
                  {
                    required: true,
                    message: "请输入",
                  },
                ],
                initialValue: this.state.offLineNum,
              })(<Input />)}
          </FormItem>
          <FormItem hidden={this.props.stubId.eventType != 8} {...formItemLayout} label={this.state.internationalization.title12}>
              {getFieldDecorator("offLineTime", {
                rules: [
                  {
                    required: true,
                    message: "请输入",
                  },
                ],
                initialValue: this.state.offLineTime,
              })(<Input />)}
          </FormItem>
          <FormItem {...tailFormItemLayout} style={{ marginTop: 14 }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}>
              {this.state.internationalization.btn1}
            </Button>
          </FormItem> 
        </Form>
      </div>
    );
  }
}


const EventMonitorCfgUpdate = Form.create()(EventMonitorCfgUpdateClass);

export default injectIntl(EventMonitorCfgUpdate);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/EventMonitorCfgUpdate.js